package com.wintermar.inspection.di

import com.apollographql.apollo.ApolloClient
import com.wintermar.inspection.AppDatabase
import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.feature.data.repository.AuthRepositoryImpl
import com.wintermar.inspection.feature.data.repository.ReferenceRepositoryImpl
import com.wintermar.inspection.feature.data.repository.InspectionRepositoryImpl
import com.wintermar.inspection.feature.data.repository.TemplateRepositoryImpl
import com.wintermar.inspection.feature.data.repository.answer.AnswerChunkFileRepositoryImpl
import com.wintermar.inspection.feature.data.repository.answer.AnswerFileRepositoryImpl
import com.wintermar.inspection.feature.data.repository.answer.AnswerLocationRepositoryImpl
import com.wintermar.inspection.feature.data.repository.answer.AnswerRepositoryImpl
import com.wintermar.inspection.feature.data.repository.answer.AnswerSelectionRepositoryImpl
import com.wintermar.inspection.feature.domain.repository.AuthRepository
import com.wintermar.inspection.feature.domain.repository.ReferenceRepository
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerChunkFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerLocationRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerSelectionRepository
import org.koin.dsl.module

val repositoryModule = module {
    single<AuthRepository> { AuthRepositoryImpl(get<ApolloClient>()) }
    single<TemplateRepository> {
        TemplateRepositoryImpl(
            apolloClient = get<ApolloClient>(),
            appDatabase = get<AppDatabase>()
        )
    }
    single<ReferenceRepository> {
        ReferenceRepositoryImpl(
            apolloClient = get<ApolloClient>(),
            appDatabase = get<AppDatabase>()
        )
    }
    single<InspectionRepository> {
        InspectionRepositoryImpl(
            apolloClient = get<ApolloClient>(),
            appDatabase = get<AppDatabase>(),
            appSetting = get<AppSetting>()
        )
    }
    single<AnswerRepository> {
        AnswerRepositoryImpl(
            apolloClient = get<ApolloClient>(),
            appDatabase = get<AppDatabase>()
        )
    }
    single<AnswerLocationRepository> {
        AnswerLocationRepositoryImpl(
            appDatabase = get<AppDatabase>()
        )
    }
    single<AnswerSelectionRepository> {
        AnswerSelectionRepositoryImpl(
            appDatabase = get<AppDatabase>()
        )
    }
    single<AnswerChunkFileRepository> {
        AnswerChunkFileRepositoryImpl(
            apolloClient = get<ApolloClient>(),
            appDatabase = get<AppDatabase>()
        )
    }
    single<AnswerFileRepository> {
        AnswerFileRepositoryImpl(
            appDatabase = get<AppDatabase>()
        )
    }
}
